import type { BaseTextProps } from './BaseText';
import type { HelpTextContent, HelpTextProps } from './HelpText';

export interface OldBaseTextProps extends Omit<BaseTextProps, 'typography'> {
  /** @deprecated typography를 대신 사용해주세요. */
  kind?: BaseTextProps['typography'];
}

export function convertOldBaseTextProps(props: OldBaseTextProps): BaseTextProps {
  const { kind, ...restProps } = props;

  return {
    ...restProps,
    typography: kind,
  };
}

export interface OldHelpTextContent extends Omit<HelpTextContent, 'description' | 'content'> {
  /** @deprecated description을 대신 사용해주세요. */
  subtitle?: HelpTextContent['description'];
  /** @deprecated content를 대신 사용해주세요. */
  text?: HelpTextContent['content'];
}

export interface OldHelpTextProps extends Omit<HelpTextProps, 'contents'> {
  contents: OldHelpTextContent[];
}

export function convertOldHelpTextProps(props: OldHelpTextProps): HelpTextProps {
  return {
    ...props,
    contents: props.contents.map(({ subtitle, text }) => ({
      description: subtitle,
      content: text,
    })),
  };
}
